import { WifiOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useOnline } from '@/lib/online'

/** Never pretends success: tells the person that changes cannot be saved right now. */
export function OfflineBanner() {
  const { t } = useTranslation()
  const online = useOnline()
  if (online) return null
  return (
    <div role="status" className="border-b border-warning bg-warning-bg px-4 py-3 text-small text-warning">
      <div className="mx-auto flex max-w-page items-start gap-2">
        <WifiOff aria-hidden className="mt-0.5 size-4 shrink-0" />
        <p>{t('states.offline.banner')}</p>
      </div>
    </div>
  )
}
